var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<div class=\"title-bar clearfix\">\r\n  <div class=\"page-title h1\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"entityIdentifiers") : depth0)) != null ? lookupProperty(stack1,"entityName") : stack1), depth0))
    + "</div>\r\n</div>\r\n<div class=\"header-bar-container\"></div>\r\n<div class=\"breadcrumb-container\"></div>\r\n\r\n<div class=\"m-t-n h2\">Apply to Edit Books and Records Locations</div>\r\n\r\n<div class=\"entity-records-location-change-form-container\"></div>";
},"useData":true});